import {PureComponent} from 'react';

export default class HeaderGap extends PureComponent {
    render() {
        return null;
    }
}
